import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const PILLARS = [
  { k: 'Consistency', v: 'Structured rules that reward disciplined, repeatable execution.' },
  { k: 'Discipline', v: 'Risk management and objectivity over short-term impulses.' },
  { k: 'Development', v: 'An ecosystem for long-term trader growth, not quick wins.' },
];

const VALUES = [
  'Structured evaluation model',
  'Transparent trading rules',
  'Scalable account progression',
  'Performance-based reward system',
  'Built for synthetic index traders',
];

export default function About() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 py-20">
        <div className="label-sm mb-3">About Traders Spring Group</div>
        <h1 className="font-display text-4xl sm:text-5xl leading-[1.05]">
          A structured home for <span className="text-[#00ff66]">synthetic index traders</span>.
        </h1>

        <div className="mt-10 space-y-6 text-zinc-300 leading-relaxed">
          <p>
            <strong className="text-white">Traders Spring Group</strong> is a trading evaluation and development platform
            built for synthetic index traders.
          </p>
          <p>
            Our programs are designed to assess trading skill, discipline, and risk management within a structured
            environment using <strong className="text-white">simulated accounts</strong>. We do not manage client funds, act as a broker,
            or provide investment services.
          </p>
          <p>
            We provide traders with the opportunity to demonstrate their abilities and earn
            <strong className="text-white"> performance-based rewards</strong> based on their results. Our focus is simple:
            consistency, discipline, and long-term trader development.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-14">
          {PILLARS.map(p => (
            <div key={p.k} className="card-tech rounded-lg p-6">
              <div className="label-sm mb-2">{p.k}</div>
              <div className="font-display text-xl leading-snug">{p.v}</div>
            </div>
          ))}
        </div>

        <section className="mt-14">
          <div className="label-sm mb-3">Why traders choose us</div>
          <h2 className="font-display text-3xl">Built to reward real skill.</h2>
          <ul className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3">
            {VALUES.map(v => (
              <li key={v} className="card-tech rounded-lg p-4 flex gap-3 items-start">
                <CheckCircle2 size={16} className="text-[#00ff66] mt-1" />
                <span className="text-sm text-zinc-200">{v}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Legal disclaimer */}
        <div className="card-tech rounded-lg p-6 mt-14">
          <div className="label-sm mb-3">Legal Disclaimer</div>
          <p className="text-sm text-zinc-300 leading-relaxed">
            <strong className="text-white">Traders Spring Group is not a broker, financial institution, or investment company.</strong>
            {' '}We do not accept deposits or manage client funds.
          </p>
          <p className="text-sm text-zinc-400 leading-relaxed mt-3">
            All trading activities are conducted in simulated environments and are intended for evaluation and educational
            purposes only. Any rewards provided are based on simulated trading performance and adherence to program rules.
          </p>
          <ul className="mt-4 space-y-2 text-xs text-zinc-500">
            <li><span className="text-zinc-300">• Educational and Evaluation Purposes Only:</span> The Deriv demo platform is provided exclusively for the purpose of evaluating traders in our program.</li>
            <li><span className="text-zinc-300">• No Affiliation with Deriv:</span> Traders Spring Group operates independently and is not affiliated with Deriv. Deriv is a third-party service provider, and any use of their platform is subject to their own terms and conditions.</li>
            <li><span className="text-zinc-300">• User Compliance:</span> It is your responsibility to review and comply with Deriv's terms and conditions.</li>
            <li><span className="text-zinc-300">• Regular Monitoring and Compliance:</span> We continuously monitor our operations to ensure compliance with applicable laws and regulations.</li>
          </ul>
        </div>

        <div className="mt-12 flex gap-3">
          <Link to="/plans" className="btn-primary" data-testid="about-start">Start an evaluation <ArrowRight size={16} /></Link>
          <Link to="/faq" className="btn-ghost" data-testid="about-faq">Read the FAQ</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
